/**
 * Centralized Route Map for Bible Contest Web Application
 * Ensures type-safe URL references across Navbar, Guards, and Page Links.
 */
export const ROUTES = {
  PUBLIC: {
    HOME: '/',
    ABOUT: '/',
    VOLUNTEER: '/volunteer',
    CAREERS: '/careers',
    JOIN_US: '/join-us',
    DONATE: '/donate',
    FUNDRAISING: '/fundraising',
    BLOG: '/blog',
    BLOG_DETAIL: '/blog/:slug',
    SUPPORT: '/support',
    STUDIO: '/manage-quizzes',
    REFERRAL: '/r/:code',
    JOIN: '/join',
  },
  GAMES: {
    PLAY: '/play',
    SEASON: '/play/season/:seasonId',
    QUIZ: '/play/season/:seasonId/quiz/:quizId',
    GAME: '/play/season/:seasonId/quiz/:quizId/play',
    RESULTS: '/play/season/:seasonId/quiz/:quizId/results',
    LEADERBOARD: '/play/season/:seasonId/leaderboard',
    QUIZ_LEADERBOARD: '/play/season/:seasonId/quiz/:quizId/leaderboard',
    GLOBAL_LEADERBOARD: '/leaderboard',
    ANSWERS: '/play/season/:seasonId/quiz/:quizId/answers',
  },
  STUDIO: {
    ROOT: '/manage-quizzes',
    GAMES: '/manage-quizzes',
    SEASON_DASHBOARD: '/manage-quizzes/season/dashboard',
    CREATE_SEASON: '/manage-quizzes/season/create',
    UPDATE_SEASON: '/manage-quizzes/season/update',
    CREATE_QUIZ: '/manage-quizzes/quizzes/create',
    UPDATE_QUIZ: '/manage-quizzes/quizzes/update',
    CREATE_QUESTION: '/manage-quizzes/questions/create',
    UPDATE_QUESTION: '/manage-quizzes/questions/update',
    QUESTIONS: '/manage-quizzes/questions',
    QUIZ_RESULTS: '/manage-quizzes/quiz-results',
  },
  AUTH: {
    LOGIN: '/login',
  },
  USER: {
    PROFILE: '/profile',
    PLAYER: '/profile/:userId',
    EDIT: '/profile/edit',
  },
  LEGAL: {
    PRIVACY: '/privacy-policy',
    TERMS: '/terms-and-conditions',
    DELETION_REQUEST: '/delete-user-request',
  },
};

// Aliases for compatibility
ROUTES.ADMIN = {
  DASHBOARD: ROUTES.STUDIO,
};
